// Comprehensive pool of 160+ authentic Pakistani customer names with cultural, professional, and regional titles
export const PAKISTANI_NAMES_POOL = [
  { ur: 'حاجی محمد ادریس', en: 'Haji Muhammad Idrees' },
  { ur: 'طارق محمود صدیقی', en: 'Tariq Mehmood Siddiqui' },
  { ur: 'سید عابد علی شاہ', en: 'Syed Abid Ali Shah' },
  { ur: 'ڈاکٹر فرہاد خان ترین', en: 'Dr. Farhad Khan Tareen' },
  { ur: 'عائشہ صدیقہ', en: 'Ayesha Siddiqa' },
  { ur: 'ملک عثمان غنی اعوان', en: 'Malik Usman Ghani Awan' },
  { ur: 'انجینئر بلال احمد چوہان', en: 'Engr. Bilal Ahmed Chauhan' },
  { ur: 'پروفیسر انعام الحق ہاشمی', en: 'Prof. Inam-ul-Haq Hashmi' },
  { ur: 'چوہدری نوید اختر گجر', en: 'Chaudhry Naveed Akhtar' },
  { ur: 'راؤ نعیم الرحمن', en: 'Rao Naeem-ur-Rehman' },
  { ur: 'ثناء فاطمہ زہراء', en: 'Sana Fatima' },
  { ur: 'عبداللہ خان نیازی', en: 'Abdullah Khan Niazi' },
  { ur: 'میاں محمد حمزہ', en: 'Mian Muhammad Hamza' },
  { ur: 'زاہدہ پروین', en: 'Zahida Parveen' },
  { ur: 'سردار اسفندیار خان جوگیزئی', en: 'Sardar Asfandyar Khan' },
  { ur: 'محمد کامران بٹ', en: 'Muhammad Kamran Butt' },
  { ur: 'حکیم عبدالباسط قریشی', en: 'Hakeem Abdul Basit' },
  { ur: 'وقاص علی گوہر', en: 'Waqas Ali Gohar' },
  { ur: 'مریم بی بی', en: 'Maryam Bibi' },
  { ur: 'رضوان الحق عباسی', en: 'Rizwan-ul-Haq Abbasi' },
  { ur: 'رانا ذیشان حیدر', en: 'Rana Zeeshan Haider' },
  { ur: 'فوزیہ پروین شاہ', en: 'Fouzia Parveen' },
  { ur: 'محبوب عالم مغل', en: 'Mehboob Alam Mughal' },
  { ur: 'خرم شہزاد ڈار', en: 'Khurram Shahzad Dar' },
  { ur: 'حاجی رشید احمد', en: 'Haji Rasheed Ahmed' },
  { ur: 'ڈاکٹر شفیق الرحمن', en: 'Dr. Shafeeq-ur-Rehman' },
  { ur: 'صائمہ عروج', en: 'Saima Urooj' },
  { ur: 'چوہدری فیاض گل', en: 'Chaudhry Fayyaz Gul' },
  { ur: 'سید ثاقب علی رضوی', en: 'Syed Saqib Ali Rizvi' },
  { ur: 'ناصر محمود ورک', en: 'Nasir Mehmood Virk' },
  { ur: 'انجینئر علی رضا کاظمی', en: 'Engr. Ali Raza Kazmi' },
  { ur: 'تہمینہ کوثر', en: 'Tehmina Kausar' },
  { ur: 'سردار عبدالمجید بزدار', en: 'Sardar Abdul Majeed' },
  { ur: 'میاں طاہر جاوید', en: 'Mian Tahir Javed' },
  { ur: 'بشیر احمد کھوکھر', en: 'Basheer Ahmed Khokhar' },
  { ur: 'ڈاکٹر فوزیہ تبسم', en: 'Dr. Fouzia Tabassum' },
  { ur: 'راجہ عاصم کیانی', en: 'Raja Asim Kiani' },
  { ur: 'ملک جہانگیر خان', en: 'Malik Jahangir Khan' },
  { ur: 'محمد عرفان انصاری', en: 'Muhammad Irfan Ansari' },
  { ur: 'سید عقیل عباس نقوی', en: 'Syed Aqeel Abbas' },
  { ur: 'حاجی ممتاز دین', en: 'Haji Mumtaz Din' },
  { ur: 'مسز شائستہ فرحت', en: 'Mrs. Shaista Farhat' },
  { ur: 'زبیر احمد بھٹی', en: 'Zubair Ahmed Bhatti' },
  { ur: 'اسد اللہ خان مروت', en: 'Asadullah Khan Marwat' },
  { ur: 'ڈاکٹر جنید اقبال', en: 'Dr. Junaid Iqbal' },
  { ur: 'چوہدری اعجاز حسین', en: 'Chaudhry Ijaz Hussain' },
  { ur: 'قاری عطاء الرحمن', en: 'Qari Ata-ur-Rehman' },
  { ur: 'ناہید اختر', en: 'Naheed Akhtar' },
  { ur: 'حافظ محمد سلیمان', en: 'Hafiz Muhammad Suleman' },
  { ur: 'وقار احمد ملک', en: 'Waqar Ahmed Malik' },
  { ur: 'سید مجتبیٰ حسن شیرازی', en: 'Syed Mujtaba Hassan' },
  { ur: 'پروفیسر شاہد محمود', en: 'Prof. Shahid Mehmood' },
  { ur: 'رانا تنویر احمد', en: 'Rana Tanveer Ahmed' },
  { ur: 'عمارہ بی بی', en: 'Amara Bibi' },
  { ur: 'خورشید عالم خان', en: 'Khurshid Alam Khan' },
  { ur: 'انجینئر حامد نذیر', en: 'Engr. Hamid Nazir' },
  { ur: 'سردار غوث بخش مری', en: 'Sardar Ghaus Bakhsh' },
  { ur: 'میاں سرفراز اقبال', en: 'Mian Sarfraz Iqbal' },
  { ur: 'ڈاکٹر ناصر علی بلوچ', en: 'Dr. Nasir Ali Baloch' },
  { ur: 'فرزانہ یاسمین', en: 'Farzana Yasmeen' },
  { ur: 'چوہدری طلال افضل', en: 'Chaudhry Talal Afzal' },
  { ur: 'حاجی محمد شریف', en: 'Haji Muhammad Sharif' },
  { ur: 'راؤ ساجد علی', en: 'Rao Sajid Ali' },
  { ur: 'سید علی گوہر شاہ', en: 'Syed Ali Gohar Shah' },
  { ur: 'محمد عاطف رفیق', en: 'Muhammad Atif Rafique' },
  { ur: 'نازیہ پروین', en: 'Nazia Parveen' },
  { ur: 'قاضی عبدالقدوس', en: 'Qazi Abdul Qudoos' },
  { ur: 'عامر سہیل چیمہ', en: 'Aamir Sohail Cheema' },
  { ur: 'ڈاکٹر کامران خان خٹک', en: 'Dr. Kamran Khan' },
  { ur: 'صدف جاوید', en: 'Sadaf Javed' },
  { ur: 'مرزا عثمان بیگ', en: 'Mirza Usman Baig' },
  { ur: 'ملک ندیم اختر', en: 'Malik Nadeem Akhtar' },
  { ur: 'سردار بابر خان رند', en: 'Sardar Babar Khan' },
  { ur: 'محمد بلال تارڑ', en: 'Muhammad Bilal Tarar' },
  { ur: 'شاہدہ بیگم', en: 'Shahida Begum' },
  { ur: 'سید فرحان شاہ ترمذی', en: 'Syed Farhan Shah' },
  { ur: 'چوہدری ماجد علی', en: 'Chaudhry Majid Ali' },
  { ur: 'انجینئر اسامہ خالد', en: 'Engr. Osama Khalid' },
  { ur: 'راجہ خرم نواز', en: 'Raja Khurram Nawaz' },
  { ur: 'حکیم محمد الیاس', en: 'Hakeem Muhammad Ilyas' },
  { ur: 'ریحانہ کوثر', en: 'Rehana Kausar' },
  { ur: 'نواب زادہ اورنگزیب خان', en: 'Nawabzada Aurangzeb' },
  { ur: 'میاں شہباز انور', en: 'Mian Shahbaz Anwar' },
  { ur: 'ڈاکٹر ساجدہ بی بی', en: 'Dr. Sajida Bibi' },
  { ur: 'ارسلان حیدر باجوہ', en: 'Arslan Haider Bajwa' },
  { ur: 'راؤ مسعود احمد', en: 'Rao Masood Ahmed' },
  { ur: 'عتیق الرحمن غوری', en: 'Atiq-ur-Rehman Ghauri' },
  { ur: 'حاجی منظور الٰہی', en: 'Haji Manzoor Elahi' },
  { ur: 'سمیرا یاسمین', en: 'Sumaira Yasmeen' },
  { ur: 'سید واجد علی زیدی', en: 'Syed Wajid Ali Zaidi' },
  { ur: 'چوہدری سلیم اللہ', en: 'Chaudhry Saleemullah' },
  { ur: 'محمد عدنان صدیقی', en: 'Muhammad Adnan Siddiqui' },
  { ur: 'ڈاکٹر ثاقب منیر', en: 'Dr. Saqib Muneer' },
  { ur: 'ملک فیاض حسین اعوان', en: 'Malik Fayyaz Hussain' },
  { ur: 'طاہرہ جبیں', en: 'Tahira Jabeen' },
  { ur: 'رانا شاہد اقبال', en: 'Rana Shahid Iqbal' },
  { ur: 'سردار داؤد خان کاسی', en: 'Sardar Dawood Khan' },
  { ur: 'انجینئر وقاص محمود', en: 'Engr. Waqas Mehmood' },
  { ur: 'میاں نثار احمد', en: 'Mian Nisar Ahmed' },
  { ur: 'شہلا بانو', en: 'Shehla Bano' },
  { ur: 'قاری مطیع اللہ خان', en: 'Qari Mutee-ullah' },
  { ur: 'ظفر اقبال گوندل', en: 'Zafar Iqbal Gondal' },
  { ur: 'ڈاکٹر عمر دراز خان', en: 'Dr. Umar Daraz Khan' },
  { ur: 'سید باقر علی شاہ', en: 'Syed Baqir Ali Shah' },
  { ur: 'انجم پروین', en: 'Anjum Parveen' },
  { ur: 'چوہدری اسد محمود', en: 'Chaudhry Asad Mehmood' },
  { ur: 'حاجی حبیب الرحمن', en: 'Haji Habib-ur-Rehman' },
  { ur: 'راؤ آفتاب احمد', en: 'Rao Aftab Ahmed' },
  { ur: 'محمد ہارون رشید', en: 'Muhammad Haroon Rasheed' },
  { ur: 'شبنم بیگم', en: 'Shabnam Begum' },
  { ur: 'مرزا سلیم بیگ', en: 'Mirza Saleem Baig' },
  { ur: 'سردار فتح محمد مگسی', en: 'Sardar Fateh Muhammad' },
  { ur: 'انجینئر فہد زمان', en: 'Engr. Fahad Zaman' },
  { ur: 'ڈاکٹر خدیجہ طارق', en: 'Dr. Khadija Tariq' },
  { ur: 'میاں عابد رشید', en: 'Mian Abid Rasheed' },
  { ur: 'چوہدری کامران اصغر', en: 'Chaudhry Kamran Asghar' },
  { ur: 'حکیم قاسم علی لودھی', en: 'Hakeem Qasim Ali' },
  { ur: 'روبینہ پروین', en: 'Rubina Parveen' },
  { ur: 'سید تصدق حسین شاہ', en: 'Syed Tasaddiq Hussain' },
  { ur: 'ملک امتیاز احمد', en: 'Malik Imtiaz Ahmed' },
  { ur: 'راجہ مسعود کیانی', en: 'Raja Masood Kiani' },
  { ur: 'محمد سفیان ڈار', en: 'Muhammad Sufyan Dar' },
  { ur: 'ڈاکٹر اسد اللہ خان', en: 'Dr. Asadullah Khan' },
  { ur: 'عاصمہ بی بی', en: 'Asma Bibi' },
  { ur: 'چوہدری عرفان سندھو', en: 'Chaudhry Irfan Sandhu' },
  { ur: 'حاجی عبدالمجید', en: 'Haji Abdul Majeed' },
  { ur: 'راؤ طارق محمود', en: 'Rao Tariq Mehmood' },
  { ur: 'سید شمس الدین بخاری', en: 'Syed Shams-ud-Din' },
  { ur: 'نائلہ بتول', en: 'Naila Batool' },
  { ur: 'میاں عامر ریاض', en: 'Mian Aamir Riaz' },
  { ur: 'سردار بلال خان شیرانی', en: 'Sardar Bilal Khan' },
  { ur: 'ڈاکٹر حبیب اللہ آفریدی', en: 'Dr. Habibullah Afridi' },
  { ur: 'انجینئر نعمان اشرف', en: 'Engr. Noman Ashraf' },
  { ur: 'محمد ثاقب گھمن', en: 'Muhammad Saqib Ghumman' },
  { ur: 'شازیہ رحمن', en: 'Shazia Rehman' },
  { ur: 'چوہدری انور الحق', en: 'Chaudhry Anwar-ul-Haq' },
  { ur: 'ملک ارشد محمود', en: 'Malik Arshad Mehmood' },
  { ur: 'سید خرم علی نقوی', en: 'Syed Khurram Ali' },
  { ur: 'حاجی نور محمد', en: 'Haji Noor Muhammad' },
  { ur: 'فائزہ شاہد', en: 'Faiza Shahid' },
  { ur: 'رانا محمد کاشف', en: 'Rana Muhammad Kashif' },
  { ur: 'سردار جہانزیب خان ترین', en: 'Sardar Jehanzeb Khan' },
  { ur: 'ڈاکٹر سلیمان خان شنواری', en: 'Dr. Suleman Khan' },
  { ur: 'میاں ضیاء الرحمن', en: 'Mian Zia-ur-Rehman' },
  { ur: 'نسرین اختر', en: 'Nasreen Akhtar' },
  { ur: 'قاضی فضل الرحمن', en: 'Qazi Fazal-ur-Rehman' },
  { ur: 'چوہدری بابر سلیم', en: 'Chaudhry Babar Saleem' },
  { ur: 'انجینئر یاسر حمید', en: 'Engr. Yasir Hameed' },
  { ur: 'سید منور علی شاہ', en: 'Syed Munawar Ali Shah' },
  { ur: 'محمد نعمان طاہر', en: 'Muhammad Noman Tahir' },
  { ur: 'مسز نزہت پروین', en: 'Mrs. Nuzhat Parveen' },
  { ur: 'راؤ فرخ حمید', en: 'Rao Farrukh Hameed' },
  { ur: 'حکیم فیاض احمد قادری', en: 'Hakeem Fayyaz Ahmed' },
  { ur: 'ملک ساجد اقبال کھوکھر', en: 'Malik Sajid Iqbal' },
  { ur: 'سردار اعظم خان کاکڑ', en: 'Sardar Azam Khan Kakar' },
  { ur: 'چوہدری حماد سرور', en: 'Chaudhry Hammad Sarwar' },
  { ur: 'ڈاکٹر فہیم احمد صدیقی', en: 'Dr. Faheem Ahmed' },
  { ur: 'سید راحت علی شاہ', en: 'Syed Rahat Ali Shah' },
  { ur: 'محمد جنید بٹ', en: 'Muhammad Junaid Butt' },
  { ur: 'رخسانہ کوثر', en: 'Rukhsana Kausar' }
];

// Comprehensive pool of 50+ Pakistani cities
export const PAKISTANI_CITIES_POOL = [
  { ur: 'لاہور', en: 'Lahore' },
  { ur: 'اسلام آباد', en: 'Islamabad' },
  { ur: 'راولپنڈی', en: 'Rawalpindi' },
  { ur: 'پشاور', en: 'Peshawar' },
  { ur: 'کراچی', en: 'Karachi' },
  { ur: 'فیصل آباد', en: 'Faisalabad' },
  { ur: 'ملتان', en: 'Multan' },
  { ur: 'گوجرانوالہ', en: 'Gujranwala' },
  { ur: 'سیالکوٹ', en: 'Sialkot' },
  { ur: 'ایبٹ آباد', en: 'Abbottabad' },
  { ur: 'بہاولپور', en: 'Bahawalpur' },
  { ur: 'سرگودھا', en: 'Sargodha' },
  { ur: 'کوئٹہ', en: 'Quetta' },
  { ur: 'حیدرآباد', en: 'Hyderabad' },
  { ur: 'گجرات', en: 'Gujrat' },
  { ur: 'مردان', en: 'Mardan' },
  { ur: 'سوات', en: 'Swat' },
  { ur: 'ساہیوال', en: 'Sahiwal' },
  { ur: 'ڈیرہ غازی خان', en: 'Dera Ghazi Khan' },
  { ur: 'مظفر آباد', en: 'Muzaffarabad' },
  { ur: 'میرپور آزاد کشمیر', en: 'Mirpur AJK' },
  { ur: 'شیخوپورہ', en: 'Sheikhupura' },
  { ur: 'رحیم یار خان', en: 'Rahim Yar Khan' },
  { ur: 'وہاڑی', en: 'Vehari' },
  { ur: 'قصور', en: 'Kasur' },
  { ur: 'جھنگ', en: 'Jhang' },
  { ur: 'چنیوٹ', en: 'Chiniot' },
  { ur: 'اوکاڑہ', en: 'Okara' },
  { ur: 'منڈی بہاؤالدین', en: 'Mandi Bahauddin' },
  { ur: 'چکوال', en: 'Chakwal' },
  { ur: 'جہلم', en: 'Jhelum' },
  { ur: 'مانسہرہ', en: 'Mansehra' },
  { ur: 'بنوں', en: 'Bannu' },
  { ur: 'کوہاٹ', en: 'Kohat' },
  { ur: 'ڈیرہ اسماعیل خان', en: 'D.I. Khan' },
  { ur: 'سکھر', en: 'Sukkur' },
  { ur: 'لاڑکانہ', en: 'Larkana' },
  { ur: 'نوابشاہ', en: 'Nawabshah' },
  { ur: 'خضدار', en: 'Khuzdar' },
  { ur: 'لورالائی', en: 'Loralai' },
  { ur: 'تربت', en: 'Turbat' },
  { ur: 'گوادر', en: 'Gwadar' },
  { ur: 'میاں والی', en: 'Mianwali' },
  { ur: 'خانیوال', en: 'Khanewal' },
  { ur: 'پاکپتن', en: 'Pakpattan' },
  { ur: 'اٹک', en: 'Attock' },
  { ur: 'حافظ آباد', en: 'Hafizabad' },
  { ur: 'ہری پور', en: 'Haripur' },
  { ur: 'وزیر آباد', en: 'Wazirabad' }
];

// Islamic / Pakistani Day Names (Saturday to Friday week cycle)
export const URDU_DAY_NAMES = [
  'اتوار',    // 0 = Sunday
  'پیر',      // 1 = Monday
  'منگل',     // 2 = Tuesday
  'بدھ',      // 3 = Wednesday
  'جمعرات',   // 4 = Thursday
  'جمعہ',     // 5 = Friday
  'ہفتہ'      // 6 = Saturday
];

export const EN_DAY_NAMES = [
  'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'
];

// Helper: Get integer absolute calendar day (changes precisely at midnight)
export const getAbsoluteDayNumber = (d = new Date()) => {
  const mid = new Date(d);
  mid.setHours(0, 0, 0, 0);
  return Math.floor(mid.getTime() / 86400000);
};

// Helper: Deterministic string hash for product salting
export const getStringHash = (str) => {
  if (!str) return 0;
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 33 + str.charCodeAt(i)) >>> 0;
  }
  return hash;
};

// 7-Day Rolling CCTV Schedule (Distribution of orders across the 7-day rolling window)
// Orders older than 7 days automatically roll out and are replaced by fresh daily orders!
const CCTV_ROLLING_SLOTS = [
  // Today (Day 0) - Most recent orders placed today
  { daysAgo: 0, slot: 0, minsAgo: 4 },
  { daysAgo: 0, slot: 1, minsAgo: 14 },
  { daysAgo: 0, slot: 2, minsAgo: 26 },
  { daysAgo: 0, slot: 3, minsAgo: 48 },
  { daysAgo: 0, slot: 4, minsAgo: 110 },
  { daysAgo: 0, slot: 5, minsAgo: 210 },

  // Yesterday (Day 1) - "1 دن پہلے"
  { daysAgo: 1, slot: 0 },
  { daysAgo: 1, slot: 1 },
  { daysAgo: 1, slot: 2 },

  // 2 Days Ago (Day 2) - "2 دن پہلے"
  { daysAgo: 2, slot: 0 },
  { daysAgo: 2, slot: 1 },

  // 3 Days Ago (Day 3) - "3 دن پہلے"
  { daysAgo: 3, slot: 0 },
  { daysAgo: 3, slot: 1 },

  // 4 Days Ago (Day 4) - "4 دن پہلے"
  { daysAgo: 4, slot: 0 },

  // 5 Days Ago (Day 5) - "5 دن پہلے"
  { daysAgo: 5, slot: 0 },

  // 6 Days Ago (Day 6) - "6 دن پہلے"
  { daysAgo: 6, slot: 0 }
  // On Day 8 (7 days elapsed), orders from 7 days ago naturally roll off, like CCTV!
];

// Formats the realistic rolling CCTV time tag
export const formatCctvTimeAgo = (daysAgo, minsAgo = 15, targetDate = new Date(), lang = 'ur') => {
  const isUr = lang === 'ur';

  if (daysAgo === 0) {
    if (minsAgo < 60) {
      return isUr ? `${minsAgo} منٹ پہلے` : `${minsAgo} mins ago`;
    }
    const hrs = Math.floor(minsAgo / 60);
    return isUr 
      ? (hrs === 1 ? '1 گھنٹہ پہلے' : `${hrs} گھنٹے پہلے`)
      : (hrs === 1 ? '1 hour ago' : `${hrs} hours ago`);
  }

  const dayOfWeek = targetDate.getDay();
  const dayName = isUr ? URDU_DAY_NAMES[dayOfWeek] : EN_DAY_NAMES[dayOfWeek];

  if (daysAgo === 1) {
    return isUr ? `1 دن پہلے (${dayName})` : `1 day ago (${dayName})`;
  }

  return isUr ? `${daysAgo} دن پہلے (${dayName})` : `${daysAgo} days ago (${dayName})`;
};

// Generates the 7-day rolling CCTV order list for a product (or general store)
// Bound deterministically to the actual calendar day of history!
export const getCctvRollingOrders = (product = null, lang = 'ur') => {
  const now = new Date();
  const currentDayNum = getAbsoluteDayNumber(now);
  const prodSeed = product ? getStringHash(product.id || product.nameUrdu || product.nameEn) : 0;

  const totalNames = PAKISTANI_NAMES_POOL.length;
  const totalCities = PAKISTANI_CITIES_POOL.length;

  return CCTV_ROLLING_SLOTS.map((entry, index) => {
    // The exact calendar day for this historical order
    const historicalDayNum = currentDayNum - entry.daysAgo;
    const targetDate = new Date(now.getTime() - entry.daysAgo * 86400000);

    // Person & city are deterministically tied to historicalDayNum + prodSeed + slot
    // This guarantees that tomorrow, yesterday's person stays the exact same person,
    // but their time tag shifts from "Today" to "1 دن پہلے", and so forth over 7 days!
    const nameIdx = Math.abs(historicalDayNum * 47 + prodSeed * 19 + entry.slot * 11) % totalNames;
    const cityIdx = Math.abs(historicalDayNum * 29 + prodSeed * 13 + entry.slot * 7) % totalCities;

    return {
      name: lang === 'ur' ? PAKISTANI_NAMES_POOL[nameIdx].ur : PAKISTANI_NAMES_POOL[nameIdx].en,
      city: lang === 'ur' ? PAKISTANI_CITIES_POOL[cityIdx].ur : PAKISTANI_CITIES_POOL[cityIdx].en,
      daysAgo: entry.daysAgo,
      slotIndex: index,
      timeAgoUrdu: formatCctvTimeAgo(entry.daysAgo, entry.minsAgo, targetDate, 'ur'),
      timeAgoEn: formatCctvTimeAgo(entry.daysAgo, entry.minsAgo, targetDate, 'en')
    };
  });
};
